import React, { createContext, useContext, useState } from 'react';

export const GlobalContext = createContext();

export const useGlobal = () => {
  const context = useContext(GlobalContext);
  if (!context) {
    throw new Error('useGlobal doit être utilisé au sein d\'un GlobalProvider');
  }
  return context;
};

export const GlobalProvider = ({ children }) => {
  const [activeSection, setActiveSection] = useState(0);
  const [cameraDisplay, setCameraDisplay] = useState(null); // Ajoutez la caméra ici
  
  return (
    <GlobalContext.Provider value={{ activeSection, setActiveSection, cameraDisplay, setCameraDisplay }}>
      {children}
    </GlobalContext.Provider>
  );
};